<template>
    <transition name="fade">
        <div v-if="value" class="popup_box" style="display: block">
            <div class="popup delete_category">
                <span class="page_title">{{title}}</span>
                <span class="close_popup" @click="$emit('input', false)"></span>
                <button class="btn" @click="$emit('confirm')">
                  {{ btn_ok ? btn_ok : 'OK' }}
                </button>
              <button class="btn empty" @click="$emit('input', false)">
                {{btn_cancel ? btn_cancel : 'Отмена'}}
              </button>
            </div>
        </div>
    </transition>
</template>

<script>
export default {
  name: 'ConfirmModal',
  props: ['value', 'title', 'btn_ok', 'btn_cancel'],
  emits: ['input', 'confirm', 'cancel']
}
</script>

<style scoped>

</style>
